import moment from 'moment';
import Swal from 'sweetalert2';
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
import ProductFormModal from './ProductFormModal.vue';

export default {
    name: 'Products',
    mixins: [HelperMixin],
    components: {
        PaginationHelper,
        ProductFormModal
    },

    async created() {
        await this.CheckLoginStatus();
        await Promise.all([
            this.GetAllCountries(),
            this.GetAllManufacturers(),
            this.GetAllUnitMeasures(),
            this.GetFormularyItems()
        ]);

        if (this.loginDetails && !this.hasInventoryAndStockAccessUi()) {
            this.logout();
            return;
        }

        this.GetInfo(1);
    },

    beforeDestroy() {
        clearTimeout(this.searchTimer);
    },

    computed: {
        statsCards() {
            return [
                this.statCard('إجمالي المنتجات', this.Statistics && this.Statistics.count, 'primary', 'ti ti-package'),
                this.statCard('قيمة المخزون', `${this.formatNumber(this.Statistics && this.Statistics.price)} د.ل`, 'success', 'ti ti-currency-dollar'),
                this.statCard('قرب انتهاء الصلاحية', this.Statistics && this.Statistics.productExpiryCount, 'danger', 'ti ti-alert-triangle'),
                this.statCard('التصنيفات المستخدمة', this.Statistics && this.Statistics.categoriesCount, 'info', 'ti ti-category')
            ];
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            ScreenTitle: 'سجل المنتجات',
            ScreenTitleSingle: 'منتج',
            Info: [],
            Statistics: {},
            Countries: [],
            Manufacturers: [],
            UnitMeasures: [],
            FormularyItems: [],
            SelectedItem: null,
            searchTimer: null
        };
    },

    methods: {
        moment(date) {
            if (!date) return '---';
            return moment(date).format('DD/MM/YYYY');
        },

        tableRowNumber(index) {
            return ((Number(this.pageNo) - 1) * Number(this.pageSize)) + index + 1;
        },

        statusBadgeClass(status) {
            return Number(status) === 1 ? 'bg-label-success' : 'bg-label-warning';
        },

        statusLabel(status) {
            return Number(status) === 1 ? 'نشط' : 'غير نشط';
        },

        productMeta(item) {
            return item && item.categories ? item.categories : 'بدون تصنيف';
        },

        productOrigin(item) {
            return item && (item.countryName || item.material) ? (item.countryName || item.material) : 'بلد المنشأ غير محدد';
        },

        onSearchInput() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => this.GetInfo(1), 500);
        },

        openCreateDialog() {
            this.SelectedItem = null;
            this.$refs.productFormModal.open(null);
        },

        openEditDialog(item) {
            this.SelectedItem = item;
            // تُعاد القائمة أولاً حاملةً شركة هذا المنتج، ثم تُفتح النافذة.
            const current = item && item.manufacturerId ? Number(item.manufacturerId) : null;
            const proceed = () => this.$refs.productFormModal.open(item);
            if (current) this.GetAllManufacturers(current).then(proceed).catch(proceed);
            else proceed();
        },

        openDetails(item) {
            this.$router.push({ name: 'ProductDetails', params: { id: item.id } });
        },

        GetAllUnitMeasures() {
            return this.$http.GetAllDictionaryUnitMeasures()
                .then(response => { this.UnitMeasures = response.data.info || []; })
                .catch(() => { this.UnitMeasures = []; });
        },

        /**
         * القائمة مرخّصة فقط. includeId يضمن بقاء شركة المنتج المفتوح في الخيارات
         * ولو سقط ترخيصها — بدونه يُفتح الحقل فارغاً ويمحو الحفظ الارتباط صامتاً.
         */
        GetAllManufacturers(includeId) {
            return this.$http.GetAllManufacturers(includeId)
                .then(response => { this.Manufacturers = response.data.info || []; })
                .catch(() => { this.Manufacturers = []; });
        },

        async GetAllCountries() {
            try {
                const response = await this.$http.GetAllCountries();
                this.Countries = response.data.info || [];
            } catch {
                this.Countries = [];
            }
        },

        async GetFormularyItems() {
            try {
                const response = await this.$http.GetNationalFormularyApproved('', 500);
                const root = response.data || {};
                const raw = root.info != null ? root.info : root.Info;
                const arr = Array.isArray(raw) ? raw : [];
                this.FormularyItems = arr.map((r) => ({
                    id: r.id != null ? r.id : r.Id,
                    nationalCode: r.nationalCode != null ? r.nationalCode : (r.NationalCode || ''),
                    scientificName: r.scientificName != null ? r.scientificName : (r.ScientificName || ''),
                    categoryName: r.categoryName != null ? r.categoryName : (r.CategoryName || null),
                })).filter((x) => x.id != null);
            } catch {
                this.FormularyItems = [];
            }
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo || this.pageNo || 1;
            if (!this.Search) this.$blockUI.Start();

            this.$http.GetProducts(this.pageNo, this.pageSize, this.Search)
                .then(response => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                    this.Statistics = response.data.statistics || {};
                })
                .catch(() => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = [];
                    this.Statistics = {};
                    this.pages = 0;
                });
        },

        onProductSaved() {
            this.GetInfo(this.pageNo);
        },

        showRequestError(title, err) {
            const message = err && err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع';
            this.$helper.ShowMessage('error', title, message);
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية',
                text: 'هل أنت متأكد من تغيير حالة المنتج؟',
                icon: 'question',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية'
            }).then(result => {
                if (!result.isConfirmed) return;
                this.$blockUI.Start();
                this.$http.ChangeStatusProducts(Id)
                    .then(response => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        this.GetInfo(this.pageNo);
                    })
                    .catch(err => {
                        this.$blockUI.Stop();
                        this.showRequestError('خطأ بعملية التعديل', err);
                    });
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد الحذف',
                text: 'هل أنت متأكد من حذف هذا المنتج؟',
                icon: 'warning',
                customClass: { confirmButton: 'btn btn-danger', cancelButton: 'btn btn-label-secondary ms-2' },
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: 'حذف',
                cancelButtonText: 'إلغاء'
            }).then(result => {
                if (!result.isConfirmed) return;
                this.$blockUI.Start();
                this.$http.DeleteProducts(Id)
                    .then(response => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        this.GetInfo(this.pageNo);
                    })
                    .catch(err => {
                        this.$blockUI.Stop();
                        this.showRequestError('خطأ بعملية الحذف', err);
                    });
            });
        }
    }
};
